
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generative-ai-integration-services",
      function () {
        return require("private-next-pages/generative-ai-integration-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generative-ai-integration-services"])
      });
    }
  